import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVESSearchCom} from '../containers'
function SVESSearchComPage() {
    //we are inet so id is not passed
    console.log('SV*****SVESSearchComPage')
    let { id } = useParams();
    let svparams = { 'id': id}

    console.log('SV*****SVESSearchComPage',svparams)
    
    return (
        <SVESSearchCom svparams={svparams} ></SVESSearchCom>
        
    );
}
export default SVESSearchComPage